import React from "react";
// Import the Component, you can call it whatever you like.
import GoogleFontLoader from "react-google-font-loader";
import MenuItem from "@material-ui/core/MenuItem";

const ListFont = ({ fontName, fontStyle }) => (
  <>
    {/* Use it */}
    <GoogleFontLoader
      fonts={[
        {
          font: "Roboto",
          weights: [400, 700],
        },
        {
          font: "Roboto Mono",
          weights: [400, 700],
        },
        {
          font: "Qahiri",
          weights: [400],
        },
        {
          font: "STIX Two Math",
          weights: [400],
        },
        {
          font: "Bebas Neue",
          weights: [400],
        },
        {
          font: "Anton",
          weights: [400],
        },
        {
          font: "Source Code Pro",
          weights: [200, 300, 400],
        },
        {
          font: "Teko",
          weights: [200, 300, 400],
        },
        {
          font: "Barlow Condensed",
          weights: [200, 300, 400],
        },
      ]}
      //   subsets={["cyrillic-ext", "greek"]}
    />

    <span value={2} style={{ fontFamily: fontStyle }}>
      {fontName}
    </span>
  </>
);

export default ListFont;
